import _ from 'lodash';
//import { apiSearch, apiFetch } from '../utility';
import { apiFetch } from '../utility';
const apiBase = 'document';

export const convertToPages = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.convertToPages`,
			params,
			dispatch,
			callback,
		});
	};
};
